import { Button } from "@landing/components/ui/button"

export function LandingKeepUp() {
  return (
    <section className="relative isolate z-30 py-2 sm:py-3 mb-0 md:mb-20 mt-4 px-0 sm:px-6 lg:px-6">
      <div className="w-[90%] max-w-[420px] sm:max-w-md lg:max-w-4xl mx-auto px-0 sm:px-2 lg:px-0 lg:-translate-x-4">
        <div className="relative isolate w-full mx-auto bg-white/0 rounded-3xl border border-white/0 px-6 sm:px-6 md:px-10 py-6 md:py-8 before:absolute before:inset-0 before:-z-10 before:rounded-3xl before:content-['_'] before:backdrop-blur-none">
          {/* Content */}
          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center lg:justify-between lg:translate-x-4">
            {/* Textual copy */}
            <div className="text-center lg:translate-x-4">
              <h2
                className="text-3xl md:text-4xl font-bold text-white leading-[1.08] md:leading-[1.1] mb-0 md:mb-1"
                style={{ letterSpacing: "-1px" }}
              >
                <span className="block md:hidden leading-[1.1]">
                  <div className="flex justify-center mb-3">
                    <div className="relative">
                      <img
                        src="https://a.bracky.app/assets/landing/icons/keep-up-globe.gif"
                        alt="Globe"
                        className="inline-block w-[1.3em] h-[1.3em] lg:w-[1.52em] lg:h-[1.52em]"
                        style={{ filter: "brightness(1.08) drop-shadow(0 0 15px rgba(255,248,240,0.32))" }}
                      />
                      <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-[.4rem] text-[2.2rem]" />
                    </div>
                  </div>
                  <span className="font-medium bg-linear-to-b from-white to-white/40 bg-clip-text text-transparent">
                    Sports Social Layer.
                  </span>
                  <br />
                  <span>Live on Bracket. </span>
                </span>
                <span className="hidden md:block ml-0">
                  <span className="font-normal bg-linear-to-b from-white to-white/40 bg-clip-text text-transparent">
                    Sports Social Layer.
                  </span>
                  <br />
                  Live on Bracket.{" "}
                  <span className="relative inline-block ml-1">
                    <img
                      src="https://a.bracky.app/assets/landing/icons/keep-up-globe.gif"
                      alt="Globe"
                      className="inline-block w-[1.062em] h-[1.062em]"
                      style={{ filter: "brightness(1.08) drop-shadow(0 0 15px rgba(255,248,240,0.32))" }}
                    />
                    <span className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[0.75em] md:hidden" />
                  </span>
                </span>
              </h2>
              <div className="mb-2 mt-2.5 sm:mt-2">
                <span className="block text-[#22FF65] text-[.875rem] sm:text-[1.04rem] font-mono tracking-wider uppercase [word-spacing:-0.35em]">
                  <span className="inline-block mr-1.5 w-[0.54rem] h-[0.54rem] -translate-y-[.05rem] rounded-full bg-[#22FF65] shadow-[0_0_3px_#22FF65BD,0_0_8px_#22FF65BD,0_0_15px_#22FF65BD]" />
                  Powered by the Worl<span className="-tracking-widest">d's</span>&nbsp;Fans™
                </span>
              </div>
              <p className="text-white/70 text-[1.0625rem] leading-[1.35] md:leading-[1.43] max-w-xl mx-auto mt-4 md:mt-2 py-4 lg:py-0">
                Join the <span className="font-medium text-white">Global Fan Community</span>
                <br />
                changing how the world experiences
                <br />
                <span className="font-medium text-white">Sports' Biggest Moments together</span>.
              </p>
            </div>

            {/* Skewed rule between columns - desktop only */}
            <div className="hidden lg:block lg:shrink-0">
              <div className="w-px h-56 bg-white/15 transform rotate-16 mx-0" style={{ transformOrigin: "center" }} />
            </div>

            {/* Action buttons */}
            <div className="flex flex-col gap-4 w-full lg:w-auto lg:shrink-0 lg:-translate-y-1 lg:-translate-x-4">
              {/* Desktop title */}
              <h3 className="hidden xl:block text-white opacity-70 font-semibold text-lg text-center -mb-1 mt-8 lg:mt-0">
                Stay on Top of The Action.
              </h3>
              <div className="flex flex-col lg:flex-row gap-2 lg:gap-6">
                <Button
                  asChild
                  variant="outline"
                  size="bracket"
                  className="mt-2 xl:mt-0 w-full lg:w-auto text-white border-white/50 hover:border-white font-semibold"
                >
                  <a href="https://x.com/brackethq" target="_blank" rel="noopener noreferrer">
                    <img
                      src="https://a.bracky.app/assets/icons/platforms/x-transparent-white.svg"
                      alt="X"
                      className="inline-block w-[.88rem] h-[.88rem] mr-0 shrink-0"
                    />
                    Follow @BracketHQ
                  </a>
                </Button>
                <a
                  href="mailto:hello@bracky.app"
                  className="hidden w-full lg:w-auto inline-flex items-center justify-center rounded-full font-semibold text-white h-[3.22rem] lg:py-4 px-8 transition-all duration-150 bg-white/10 hover:bg-white/20 border border-white/20 hover:border-white/30"
                >
                  <img
                    src="https://a.bracky.app/assets/icons/platforms/farcaster-icon-white.svg"
                    alt="Farcaster"
                    className="inline-block w-[.88rem] h-[.88rem] mr-2 shrink-0"
                  />
                  Follow Farcaster
                </a>
              </div>
              {/* Farcaster community CTA */}
              <a
                href="https://farcaster.xyz/~/channel/bracket/join?inviteCode=wtYFOM484K5djXWvVvHN6A"
                target="_blank"
                rel="noopener noreferrer"
                className="relative inline-flex items-center justify-center w-full lg:w-auto bg-[#001CFF] text-white font-semibold h-[3.22rem] lg:py-3 px-10 lg:px-12 rounded-full transition-all whitespace-nowrap hover:brightness-110 active:brightness-90"
              >
                <img
                  src="https://a.bracky.app/assets/icons/platforms/farcaster-icon-white.svg"
                  alt="Farcaster"
                  className="inline-block w-[.88rem] h-[.88rem] mr-2 shrink-0"
                />
                Join The Community
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
